import Axios from 'axios';
import URL from '../config/url';
import { Toast } from 'vant';
// import { from } from 'core-js/fn/array';
// import CONF from '../config';

// const { STATUS_CODE } = CONF;
// const NO_MESSAGE = [STATUS_CODE.NO_LOGIN, STATUS_CODE.NO_SELECT_SHOP];
function getQueryString(name) {
    var search = window.location.search.substring(1)
    if (!search) {
        search = window.location.hash.split('?')[1]
    }
    if(search && search.indexOf('alipay') > -1 ) {
        return undefined
    }
    if (search && search.indexOf('fileUrl')===-1 && search.indexOf('fileUrl')===-1) {
        var obj = JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
        return name ? obj[name] : obj
    }
}
const baseURL = URL.API;
const service = Axios.create({withCredentials: true, baseURL})
// const token = localStorage.getItem('token') ? localStorage.getItem('token') : getQueryString('token')? getQueryString('token') : null
// 请求拦截器
service.interceptors.request.use(config => {
    config.headers['source-host'] = 'h5'//同一账号，同一端只能登陆一个
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : getQueryString('token')? getQueryString('token') : null
    if (token) {
        config.headers['token'] = token || ''
    }
    if(getQueryString('token')!=undefined){
        localStorage.setItem("token",getQueryString('token'));
        localStorage.setItem("organ",getQueryString('organ'));
        localStorage.setItem("actor",getQueryString('actor'));
        localStorage.setItem("branch",getQueryString('branch'));
    }
    config.headers['organ'] = localStorage.getItem("organ") ? localStorage.getItem("organ") : getQueryString('organ')? getQueryString('organ'):''
    config.headers['actor'] = localStorage.getItem("actor") ? localStorage.getItem("actor") : getQueryString('actor')? getQueryString('actor'):''
    config.headers['branch'] = localStorage.getItem('branch') ? localStorage.getItem('branch') : getQueryString('branch')? getQueryString('branch'):''
    localStorage.getItem('channel') && (config.headers['channel'] = localStorage.getItem('channel'));
    return config
}, err => {
    console.error(err)
    // return Promise.reject(err)
})

// 响应拦截器
service.interceptors.response.use(config => {
    return config
}, err => {
    console.error(err)
    // return Promise.reject(err)
})

let stackArr = [];
let isPoint = false;
function loop (t=0) {
    setTimeout(() => {
        Toast({
            message: stackArr[0],
            duration: 2000,
            onClose: () => {
                stackArr.shift();
                if (stackArr.length) {
                    loop(2000);
                } else {
                    isPoint = false;
                }
            }
        })
    }, t)
}
/* eslint-disable */
function API(config) {
    const {
        url = '',
        data = null,
        params = null,
        headers = {},
        method = 'get',
        timeout = 30000,
        isToast = true
    } = config || {};
    return new Promise((resolve, reject) => {
        service({
            method, // 请求方式
            url, // 请求路径
            timeout, // 请求超时
            headers: {
                // "content-type": "application/json",
                ...headers
            }, // header体
            data, // body参数
            params, //  URL参数
            isToast//是否显示toast提示
        }).then(res => {
            if (res.data.code) {
                // Notify({ type:'danger', message:res.data.message, duration:2000 })
                if (!stackArr.includes(res.data.message)) {
                    stackArr.push(res.data.message);
                }
               
                if (!isPoint) {
                    isPoint = true;
                    if(isToast){
                        loop();
                    }
                }
                if (+res.data.code === 303 || +res.data.code === 10000) {
                    localStorage.clear();
                    // sessionStorage.clear()
                    let pathname=null;
                    if(window.location.pathname === '/goodsDetail') { // 商品详情页需要携带参数
                        // 
                        pathname=`?name=goodsDetail&`+window.location.search.substring(1)
                        window.location = `//${window.location.hostname}${window.location.port? `:${window.location.port}` : ''}/login${pathname}`
                        return 
                    }
                    if(window.location.pathname === '/buySharePage') { // 商品领取需要携带参数
                        // 
                        pathname=`?name=buySharePage&`+window.location.search.substring(1)
                        window.location = `//${window.location.hostname}${window.location.port? `:${window.location.port}` : ''}/login${pathname}`
                        return 
                    }
                    if(window.location.pathname){
                        if(window.location.search.includes(window.location.pathname.substring(1))) {// 已包含不重复追加
                            pathname = window.location.search
                        } else {
                            pathname='?name='+((window.location.pathname).substr(1))+'&'+window.location.search.substring(1)

                        }
                    }

                    // if(window.location.pathname === '/login'){ //推广链接跳转商品详情
                    //     pathname = window.location.search
                    // }
                    // window.location = `//${window.location.hostname}${window.location.port? `:${window.location.port}` : ''}/login${pathname}`
                    // resolve('跳转登录页')
                }   
            }
            resolve({
                ...res.data,
                headers: res.headers
            })
            
        }).catch(err => {
            // reject(err)
            if(err && err.message){
                // console.log(err.message);
                let message = '网络异常，请检查网络';
                if(err.message === 'Network Error'){
                    message = '网络异常，请检查网络';
                }
                if (err.message.indexOf('timeout') !== -1) {
                    message = '网络超时';
                }
                if (!stackArr.includes(message)) {
                    stackArr.push(message);
                }
               
                if (!isPoint) {
                    isPoint = true;
                    loop();
                }
            }
            return err
        })
    })
}

export default API
